// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\DTO.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * 账户信息DTO DTO类
 * 账户信息DTO
 */
export class AccountInfoDTO {
  /** 账户ID : 账户ID */
  private _accountId: string;

  /** 设置：账户ID */
  public get accountId() {
    return this._accountId;
  }

  /** 获取：账户ID */
  public set accountId(value: string) {
    this._accountId = value;
  }

  /** 登录账号 : 登录账号 */
  private _loginName: string;

  /** 设置：登录账号 */
  public get loginName() {
    return this._loginName;
  }

  /** 获取：登录账号 */
  public set loginName(value: string) {
    this._loginName = value;
  }

  /** token : token */
  private _token: string;

  /** 设置：token */
  public get token() {
    return this._token;
  }

  /** 获取：token */
  public set token(value: string) {
    this._token = value;
  }

  /** 右键地址 : 右键地址 */
  private _email: string;

  /** 设置：右键地址 */
  public get email() {
    return this._email;
  }

  /** 获取：右键地址 */
  public set email(value: string) {
    this._email = value;
  }

  /** 手机号码 : 手机号码 */
  private _mobile: string;

  /** 设置：手机号码 */
  public get mobile() {
    return this._mobile;
  }

  /** 获取：手机号码 */
  public set mobile(value: string) {
    this._mobile = value;
  }

  constructor() {
    this._accountId = '';
    this._loginName = '';
    this._token = '';
    this._email = '';
    this._mobile = '';
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  protected Deserialize(json: any): void {
    this.accountId = json.AccountId;
    this.loginName = json.LoginName;
    this.token = json.Token;
    this.email = json.Email;
    this.mobile = json.Mobile;
  }

  protected Serialize(json: any): void {
    json.AccountId = this.accountId;
    json.LoginName = this.loginName;
    json.Token = this.token;
    json.Email = this.email;
    json.Mobile = this.mobile;
  }

  static Create(json: any): AccountInfoDTO {
    const accountInfoDTO = new AccountInfoDTO();
    accountInfoDTO.Deserialize(json);
    return accountInfoDTO;
  }
}
